import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=2bf8c1b2&scoped=true&"
import script from "./InformationModal.vue?vue&type=script&lang=js&"
export * from "./InformationModal.vue?vue&type=script&lang=js&"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=2bf8c1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8c1b2",
  null
  
)

export default component.exports